import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_AVAILABLE_DATA_FEEDS,
  GET_AVAILABLE_DATA_FEEDS_SUCCESS,
  GET_AVAILABLE_DATA_FEEDS_FAILURE,
} from '../../../../../store/actionTypes';
import { getData } from '../../../../../api/ApiCommunication';

async function getAvailableFeedData(params?: any): Promise<any> {
  const response = await getData('GetAvailableDataFeed', {
    emailAddress: params.emailAddress,
  });
  return response;
}

/**
 * Saga to get AvailableFeed Data from API.
 */
export function* getAvailableFeedDataSaga(action: any) {
  try {
    const { data } = yield call(getAvailableFeedData, action.params);
    yield put({ type: GET_AVAILABLE_DATA_FEEDS_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AVAILABLE_DATA_FEEDS_FAILURE, error });
  }
}

export function* waitForAvailableFeedData() {
  yield takeLatest(GET_AVAILABLE_DATA_FEEDS, getAvailableFeedDataSaga);
}
